import { IApplicationState } from '../../types/redux';

export function selectRecommendations(state: IApplicationState) {
  return state.recommendations?.recommendations || [];
}

export function selectRecommendationsHasMore(state: IApplicationState) {
  return Boolean(state.recommendations?.hasMore);
}

export function selectRecommendationsPaginationStatus(state: IApplicationState) {
  return state.recommendations?.paginationStatus;
}

export function selectRecommendationsTotalCount(state: IApplicationState) {
  return state.recommendations?.totalCount ?? null;
}
